import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createVNode(_component_van_divider), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
      height: "64",
      width: "64",
      src: _ctx.user.avatar
    }, null, 8, ["src"])]), _createVNode(_component_van_divider), _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "姓名",
        value: $data.customerDetail.chnName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "手机号码",
        value: $data.customerDetail.mobile
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "邮箱",
        value: $data.customerDetail.email
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "地址",
        "is-link": "",
        center: "",
        "arrow-direction": "",
        to: "/wx/addrs",
        value: $options.getAddr
      }, null, 8, ["value"]), $data.customerDetail.email ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 0,
        title: "修改邮箱",
        "is-link": "",
        center: "",
        "arrow-direction": "",
        to: '/wx/updateEmail?mobile=' + $data.customerDetail.mobile
      }, null, 8, ["to"])) : _createCommentVNode("", true), !$data.customerDetail.email ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 1,
        title: "新增邮箱",
        "is-link": "",
        center: "",
        "arrow-direction": "",
        to: '/wx/updateEmail/personal?mobile=' + $data.customerDetail.mobile + '&addFlag=' + $data.addFlag
      }, null, 8, ["to"])) : _createCommentVNode("", true), _createVNode(_component_van_cell, {
        title: "退出",
        "is-link": "",
        center: "",
        "arrow-direction": "",
        onClick: $options.onLogoutClick
      }, null, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  });
}